// src/api/org/service.js
import { json } from "utils/http/client";

export const FinanceApi = {
  // list all finance by site
  listAllFinancebySite: (data) =>
    json(`/finance/get-all-transactions-of-a-site/`, {
      method: "POST",
      body: data,
    }),
  // list organization-wide transactions
  listTransactionsByOrganization: (orgId, period = "30days") =>
    json(`/org/organization/${orgId}/transactions/?period=${period}`, {
      method: "GET",
    }),

  // list all pending transactions
  listPendingTransactionsBySite: (data) =>
    json(`/finance/get-pending-transactions-of-a-site/`, {
      method: "POST",
      body: data,
    }),

  // get delivery by ID
  getDeliveryById: (id) =>
    json(`/inventory/get-a-delivery/${id}/`, {
      method: "GET",
    }),
  // list part payments of a delivery
  listPartPaymentsOfDelivery: (data) =>
    json(`/inventory/list-partpayment-of-delivery/`, {
      method: "POST",
      body: data,
    }),
  // create part payment
  createPartPayment: (data) =>
    json(`/inventory/create-partpayment/`, {
      method: "POST",
      body: data,
    }),
};
